// Import Packages
import React from 'react';

// import Helpers
import { numberToLetters } from '../../../../../../../helpers/helper';

function RangeSelection({ v, dataTableValue, size, captureDown, captureOver }) {

    return (
        v.slice(0, size === 'medium' ? 4 : 30).map((row, rowIndex) => {
            if (size === 'medium') {
                row = row.slice(0, 2);
            }
            if (rowIndex === 0) {
                return (
                    <tr>
                        {
                            row.map((col, colIndex) => {
                                // cell ex: 2-5
                                const cell = rowIndex.toString() + '-' + colIndex.toString();
                                return (
                                    <th onMouseOverCapture={() => captureOver(cell)} onMouseDownCapture={() => captureDown({}, cell)} // Empty object was sent to prevent it from selecting an area by holding ctrl

                                        className={`${dataTableValue && dataTableValue.find(x => x === cell) !== undefined ? 'active-col-for-header' : ''}`}
                                        style={{ cursor: 'default' }}
                                    >
                                        {
                                            colIndex === 0 &&
                                            <span className='tr-row-number'>
                                                {rowIndex + 1}
                                            </span>
                                        }
                                        <span className='column-letter-name'>
                                            {numberToLetters(colIndex)}
                                        </span>
                                        {col}
                                    </th>
                                )
                            })
                        }
                    </tr>
                )
            }
            return (
                <tr>
                    {
                        row.map((col, colIndex) => {
                            // cell ex: 2-5
                            const cell = rowIndex.toString() + '-' + colIndex.toString();
                            return (
                                <td onMouseOverCapture={() => captureOver(cell)} onMouseDownCapture={() => captureDown({}, cell)} // Empty object was sent to prevent it from selecting an area by holding ctrl

                                    className={`${dataTableValue && dataTableValue.find(x => x === cell) !== undefined ? 'active-col' : ''}`}
                                    style={{ cursor: 'default' }}
                                >
                                    {
                                        colIndex === 0 &&
                                        <span className='tr-row-number'>
                                            {rowIndex + 1}
                                        </span>
                                    }
                                    {col}
                                </td>
                            )

                        }

                        )
                    }
                </tr>
            )
        })
    )

}

export default RangeSelection;